import { Injectable } from '@angular/core';
import { WebSocketEventRoutingService } from './web-socket-event-routing.service';
import { Observable, Subject } from 'rxjs/Rx';
import { WSEventType } from '../../../models/WSEventType';
import { ProcessRequest } from '../../../models/process-request.model';

@Injectable({
  providedIn: 'root'
})
export class OfferWebSocketHandlerService {

  private _offerSubject: Subject<ProcessRequest>;
  private readonly _offerObservable: Observable<ProcessRequest>;

  constructor(private webSocketEventRoutingService: WebSocketEventRoutingService) {
    let subject = new Subject<any>();
    subject.asObservable().subscribe(offer => {
      this.processOffer(offer);
    });
    this.webSocketEventRoutingService.subscribe(WSEventType.OFFER, subject);
    this._offerSubject = new Subject<ProcessRequest>();
    this._offerObservable = this._offerSubject.asObservable();
  }

  get offerObservable() {
    return this._offerObservable;
  }

  private processOffer(offer: ProcessRequest) {
    this._offerSubject.next(offer);
  }
}
